import { NotificationComponent } from "./notification-component/notification.component";
import { Injectable } from "@angular/core";
import { AsiNotificationPosition, AsiNotificationService, AsiNotificationType } from "@asi-ngtools/lib";


@Injectable()
export class NotificationService {

    constructor(private asiNotificationService: AsiNotificationService) {
    }

    showSuccessNotification(message: string) {
        let asiNotificationTR = this.asiNotificationService.fromComponent(NotificationComponent, {
            position: AsiNotificationPosition.TOP_RIGHT,
            type: AsiNotificationType.SUCCESS,
            delayInMs: 3000
        });
        asiNotificationTR.getComponent().message = message;
    }

    showErrorNotification(message: string) {
        let asiNotificationTR = this.asiNotificationService.fromComponent(NotificationComponent, {
            position: AsiNotificationPosition.TOP_RIGHT,
            type: AsiNotificationType.ERROR,
            delayInMs: 3000
        });
        asiNotificationTR.getComponent().message = message;
    }

    showInfoNotification(message: string) {
        let asiNotificationTR = this.asiNotificationService.fromComponent(NotificationComponent, {
            position: AsiNotificationPosition.TOP_RIGHT,
            type: AsiNotificationType.INFO,
            delayInMs: 3000
        });
        asiNotificationTR.getComponent().message = message;
    }

    showWarningNotification(message: string) {
        let asiNotificationTR = this.asiNotificationService.fromComponent(NotificationComponent, {
            position: AsiNotificationPosition.TOP_RIGHT,
            type: AsiNotificationType.WARNING,
            delayInMs: 3000
        });
        asiNotificationTR.getComponent().message = message;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/notification/notification.service.ts